
import api from '@/api'
import type { BrowserLog } from '@/types'

export const addBrowserLog = async (email: string, applicationId: string, eventType: string) => {
  const userAgent = navigator.userAgent
  const screenWidth = screen.width
  const screenHeight = screen.height

  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#mobile_device_detection
  let hasTouchScreen = false
  if ('maxTouchPoints' in navigator) {
      hasTouchScreen = navigator.maxTouchPoints > 0
  } else {
      const mQ = matchMedia ? matchMedia('(pointer:coarse)') : null
      if (mQ && mQ.media === '(pointer:coarse)') {
          hasTouchScreen = !!mQ.matches
      } else if ('orientation' in window) {
          hasTouchScreen = true
      } else {
          hasTouchScreen =
              /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(userAgent) ||
              /\b(Android|Windows Phone|iPad|iPod)\b/i.test(userAgent)
      }
  }
  const log: BrowserLog = {
    email: email,
    applicationId: applicationId,
    eventType: eventType,
    userAgent: userAgent,
    screenWidth: screenWidth,
    screenHeight: screenHeight,
    hasTouchscreen: hasTouchScreen
  }
  await api.addBrowserLog(log)
}